(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skin-treatment-explorer"] && !Shopify.designMode) return;
  try {
    
  class SkinTreatmentExplorerComponent extends HTMLElement {
    connectedCallback() {
      this.currentDemographicFilter = 'unisex';
      this.demographicFilters = Array.from(this.querySelectorAll('[ref="demographicFilters[]"]'));
      this.zoneTabs = Array.from(this.querySelectorAll('[ref="zoneTabs[]"]'));
      this.panels = Array.from(this.querySelectorAll('[ref="panels[]"]'));
      this.hotspotButtons = Array.from(this.querySelectorAll('[ref="hotspotButtons[]"]'));
      this.filterEmptyMessages = Array.from(this.querySelectorAll('[ref="filterEmptyMessages[]"]'));
      this.glow = this.querySelector('[ref="glow"]');

      this.boundHandleTabClick = this.handleTabClick.bind(this);
      this.boundHandleTabKeydown = this.handleTabKeydown.bind(this);
      this.boundHandleHotspotClick = this.handleHotspotClick.bind(this);
      this.boundHandleDemographicFilterClick = this.handleDemographicFilterClick.bind(this);

      if (this.zoneTabs.length === 0 || this.panels.length === 0) return;

      for (const tab of this.zoneTabs) {
        tab.addEventListener('click', this.boundHandleTabClick);
        tab.addEventListener('keydown', this.boundHandleTabKeydown);
      }

      for (const hotspot of this.hotspotButtons) {
        hotspot.addEventListener('click', this.boundHandleHotspotClick);
      }

      for (const filterButton of this.demographicFilters) {
        filterButton.addEventListener('click', this.boundHandleDemographicFilterClick);
      }

      this.applyTabState(this.zoneTabs[0], false);
      this.applyDemographicFilter();
    }

    disconnectedCallback() {
      if (!this.zoneTabs) return;

      for (const tab of this.zoneTabs) {
        tab.removeEventListener('click', this.boundHandleTabClick);
        tab.removeEventListener('keydown', this.boundHandleTabKeydown);
      }

      for (const hotspot of this.hotspotButtons || []) {
        hotspot.removeEventListener('click', this.boundHandleHotspotClick);
      }

      for (const filterButton of this.demographicFilters || []) {
        filterButton.removeEventListener('click', this.boundHandleDemographicFilterClick);
      }
    }

    handleTabClick(event) {
      const tab = event.currentTarget;
      this.applyTabState(tab, true);
    }

    handleHotspotClick(event) {
      const hotspot = event.currentTarget;
      const selectedPanelId = hotspot?.dataset?.panelId;
      if (!selectedPanelId) return;

      const matchingTab = this.zoneTabs.find((tab) => tab.dataset.panelId === selectedPanelId);
      if (!matchingTab) return;

      this.applyTabState(matchingTab, false);
    }

    handleDemographicFilterClick(event) {
      const filterButton = event.currentTarget;
      const nextFilter = filterButton?.dataset?.demographicFilter || 'unisex';

      this.currentDemographicFilter = nextFilter;

      for (const button of this.demographicFilters) {
        const isActive = button === filterButton;
        button.classList.toggle('skin-treatment-explorer__chip--active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      }

      this.applyDemographicFilter();
    }

    handleTabKeydown(event) {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft' && event.key !== 'Home' && event.key !== 'End') return;

      event.preventDefault();

      const currentIndex = this.zoneTabs.indexOf(event.currentTarget);
      if (currentIndex < 0) return;

      let nextIndex = currentIndex;

      if (event.key === 'ArrowRight') {
        nextIndex = (currentIndex + 1) % this.zoneTabs.length;
      }

      if (event.key === 'ArrowLeft') {
        nextIndex = (currentIndex - 1 + this.zoneTabs.length) % this.zoneTabs.length;
      }

      if (event.key === 'Home') {
        nextIndex = 0;
      }

      if (event.key === 'End') {
        nextIndex = this.zoneTabs.length - 1;
      }

      const nextTab = this.zoneTabs[nextIndex];
      nextTab.focus();
      this.applyTabState(nextTab, true);
    }

    applyTabState(tab, shouldFocusPanel) {
      const selectedPanelId = tab.dataset.panelId;
      if (!selectedPanelId) return;

      for (const currentTab of this.zoneTabs) {
        const isActive = currentTab === tab;
        currentTab.classList.toggle('skin-treatment-explorer__zone-tab--active', isActive);
        currentTab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        currentTab.tabIndex = isActive ? 0 : -1;
      }

      for (const panel of this.panels) {
        const isActivePanel = panel.id === selectedPanelId;
        panel.classList.toggle('skin-treatment-explorer__panel--active', isActivePanel);
        panel.hidden = !isActivePanel;

        if (isActivePanel && shouldFocusPanel) {
          panel.setAttribute('tabindex', '-1');
        }
      }

      this.applyGlow(tab);
      this.applyHotspotState(selectedPanelId);
      this.applyDemographicFilter();
    }

    applyGlow(tab) {
      if (!this.glow) return;

      const glowX = tab.dataset.glowX || '50';
      const glowY = tab.dataset.glowY || '20';
      const glowSize = tab.dataset.glowSize || '16';
      const glowColor = tab.dataset.glowColor || '216, 246, 252';
      const glowOpacity = tab.dataset.glowOpacity || '0.8';

      this.glow.style.setProperty('--glow-x', `${glowX}%`);
      this.glow.style.setProperty('--glow-y', `${glowY}%`);
      this.glow.style.setProperty('--glow-size', `${glowSize}rem`);
      this.glow.style.setProperty('--glow-color', glowColor);
      this.glow.style.setProperty('--glow-opacity', glowOpacity);
      this.glow.style.background = `radial-gradient(circle, rgba(${glowColor}, ${glowOpacity}) 0%, rgba(${glowColor}, 0) 70%)`;
    }

    applyHotspotState(selectedPanelId) {
      for (const hotspot of this.hotspotButtons || []) {
        const isActive = hotspot.dataset.panelId === selectedPanelId;
        hotspot.classList.toggle('skin-treatment-explorer__hotspot--active', isActive);
      }
    }

    applyDemographicFilter() {
      for (let panelIndex = 0; panelIndex < this.panels.length; panelIndex += 1) {
        const panel = this.panels[panelIndex];
        const productLinks = Array.from(panel.querySelectorAll('.skin-treatment-explorer__product-link[data-demographic]'));
        const collectionEmptyMessage = panel.querySelector('.skin-treatment-explorer__empty--collection');
        const filterEmptyMessage = this.filterEmptyMessages[panelIndex];

        if (collectionEmptyMessage) continue;

        let visibleProductsCount = 0;

        for (const productLink of productLinks) {
          const demographic = productLink.dataset.demographic || 'unisex';
          // const shouldShow = this.currentDemographicFilter === 'unisex'
          //   ? true
          //   : demographic === this.currentDemographicFilter;
          const shouldShow = true;
          const productItem = productLink.closest('.skin-treatment-explorer__product');
          if (!productItem) continue;

          productItem.hidden = !shouldShow;
          if (shouldShow) visibleProductsCount += 1;
        }

        if (!filterEmptyMessage) continue;
        filterEmptyMessage.hidden = visibleProductsCount > 0;
      }
    }
  }

  if (!customElements.get('skin-treatment-explorer-component')) {
    customElements.define('skin-treatment-explorer-component', SkinTreatmentExplorerComponent);
  }

  } catch(e) { console.error(e); }
})();
})();
